import { useTranslation } from 'react-i18next';

export function SongInactivePill() {
  const { t } = useTranslation('common');

  return (
    <span
      data-testid='song-inactive-pill'
      className='inline-flex shrink-0 items-center gap-1.5 rounded-pill bg-danger-soft px-2 py-0.5 text-[11px] font-semibold text-danger-strong'
    >
      <span className='h-1.5 w-1.5 rounded-full bg-current' />
      {t('song_detail.inactive')}
    </span>
  );
}
